<template>
  <div class="form-subscribe">
    <form id="subscription-form" @submit.prevent="onSubmit">
    <div id="card-element" class="MyCardElement">
      <!-- Elements will create input elements here -->
    </div>

    <!-- We'll put the error messages in this element -->
    <div id="card-errors" role="alert"></div>
    <button type="submit">Subscribe</button>
  </form>
  </div>  
</template>

<script>
export default {
  data : function() {
    return {
      cardElement : null
    }
  },
  methods : {
    showCardError : function(event) {
  let displayError = document.getElementById('card-errors');
  if (event.error) {
    displayError.textContent = event.error.message;
  } else {
    displayError.textContent = '';
  }
},
    loadStripe : function() {
      let elements = this.$stripe.elements();
      this.cardElement = elements.create("card");
      this.cardElement.mount("#card-element");
      this.cardElement.on('change', this.showCardError);
    },
    createPaymentMethod : function({ card, isPaymentRetry, invoiceId }) {
// Set up payment method for recurring usage
  let billingName = document.querySelector('#name').value;
  this.$stripe.createPaymentMethod({
      type: 'card',
      card: card,
      billing_details: {
        name: billingName,
      },
    })
    .then((result) => {
      if (result.error) {
        displayError(result);
      } else {

        // if (isPaymentRetry)
        if (false) {
          // Update the payment method and retry invoice payment
          retryInvoiceWithNewPaymentMethod({
            customerId: customerId,
            paymentMethodId: result.paymentMethod.id,
            invoiceId: invoiceId,
            priceId: priceId,
          });

        } else {
          // Create the subscription
          this.createSubscription({
            customerId: customerId,
            paymentMethodId: result.paymentMethod.id,
            priceId: priceId,
          });
        }
      }
    });
    },
    createSubscription : function({ customerId, paymentMethodId, priceId }) {
      console.log(customerId, paymentMethodId, priceId);
      this.$store.dispatch('user/createSubscription', {
        customerId,
        paymentMethodId,
        priceId
      }).then((result) => {
        if (result.error) {
          // The card had an error when trying to attach it to a customer.
          throw result;
        }
        return result;
      })
      // Normalize the result to contain the object returned by Stripe.
      // Add the additional details we need.
      .then((result) => {
        return {
          paymentMethodId: paymentMethodId,
          priceId: priceId,
          subscription: result,
        };
      })
      // Some payment methods require a customer to be on session
      // to complete the payment process. Check the status of the
      // payment intent to handle these actions.
      .then(handlePaymentThatRequiresCustomerAction)
      // If attaching this card to a Customer object succeeds,
      // but attempts to charge the customer fail, you
      // get a requires_payment_method error.
      .then(handleRequiresPaymentMethod)
      // No more actions required. Provision your service for the user.
      .then(onSubscriptionComplete)
      .catch((error) => {
        // An error has happened. Display the failure to the user here.
        // We utilize the HTML element we created.
        showCardError(error);
      })
    },
    onSubmit : function() {

    }
  },
  mounted : function() {
    this.loadStripe();
  },
  beforeDestroy : function() {
    this.cardElement.destroy();
  }
}
</script>

<style lang="scss">
</style>